import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import CTypography from "../../../componets/typography";
import { FooterNavigationStyled } from "./footer-nav-styled";
import { CustomCursorContext } from "../../../contexts/cursor";
import { NAVIGATION_ITEMS } from "../../../constants";

export const FooterNavigation = ({ executeScroll }) => {
  const { setType } = useContext(CustomCursorContext);
  const [hoveredItem, setHoveredItem] = useState(null);
  const navigate = useNavigate();

  const navigationItemsDisplay = NAVIGATION_ITEMS?.map?.(({ name, route }) => {
    return (
      <CTypography
        color="var(--River-bed)"
        size="small"
        weight="bold"
        className="nav-items"
        key={name}
        id={name}
        onClick={() => (route ? navigate(route) : executeScroll({ name: name }))}
        onMouseEnter={(e) => {
          setHoveredItem(e.target.id);
          setType("hover");
        }}
        onMouseLeave={(e) => {
          setHoveredItem(null);
          setType("");
        }}
      >
        {name}
      </CTypography>
    );
  });
  return (
    <FooterNavigationStyled hoveredItem={hoveredItem}>
      {navigationItemsDisplay}
    </FooterNavigationStyled>
  );
};
